import { Injectable } from '@angular/core';
import { selectCurrentSite } from '@epicuro-next/state/site-state';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { concatMap, filter, map, take } from 'rxjs/operators';

import * as actions from '../../actions';

/**
 * Product List Init Effects
 */
@Injectable()
export class InitEffects {
  private currentSiteIsLoaded$ = this.store.pipe(
    select(selectCurrentSite),
    filter(isNonNullish),
    take(1),
  );

  public initProductLists$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.initProductLists),
      concatMap(() => this.currentSiteIsLoaded$),
      map(() => actions.loadProductLists()),
    ),
  );

  public initActiveList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.initProductLists),
      concatMap(() => this.currentSiteIsLoaded$),
      map(() => actions.loadActiveList()),
    ),
  );

  constructor(private actions$: Actions, private store: Store) {}
}
